import React, { useState,  useEffect} from 'react';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import Select from 'react-select';
import {
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  IconButton,
} from '@material-ui/core';
import { useSelector, useDispatch } from 'react-redux';

import {
  getNotComboSelector,
  addMealCombo,
  deleteMealCombo
} from '../../../../store/meal';


const DetailPanel = (props) => {
    const { rowData, onToggle} = props
    // console.log('rowData',rowData);
    const mealData = useSelector(getNotComboSelector);
    const [dishes, setDishes] = useState([])
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState({});
    const dispatch = useDispatch();


    // console.log('mealData',mealData);
    // console.log('dishes',dishes);
    // console.log('options',options);


    useEffect(() => {
      if(rowData){
        if(rowData.comboMeals && rowData.comboMeals.length > 0){
          // console.log('mealData',mealData);
          // console.log('rowData.comboMeals.map(c => c.meal.id)',rowData.comboMeals.map(c => c.meal_id));
          
          let chosenDishes = []
          mealData.forEach(m => {
              rowData.comboMeals.forEach(rd => {
                if(m.id === rd.meal_id ){
                  chosenDishes.push({
                    ...m,
                    mealcombo_id: rd.mealcombo_id
                  })
                  return
                }   
              });
          })
          // mealData.filter( m => rowData.comboMeals.map(c => c.meal_id).includes(m.id))
          // console.log('chosenDishes',chosenDishes);
          setDishes(chosenDishes)
        }
        // const currentOptions = mealData.filter( m => !rowData.comboMeals.includes(m.id)).map(o => ({"value": o.id, "label":`${o.id}. ${o.name}`}))
        const currentOptions = mealData.map(o => ({"value": o.id, "label":`${o.id}. ${o.name}`}))
        setOptions(currentOptions)
        if(currentOptions.length > 0){
          setSelectedValue(currentOptions[0])
        }
      }
      // tableRef.current.onToggleDetailPanel([0],rowData => <div>{rowData.name}</div>)
    }, [rowData]);

    const handleSelectChange = selectedOption => {
        setSelectedValue(selectedOption);
        // console.log('selectedOption',selectedOption);
      };

    const handleAdd = async () => {
      await dispatch(addMealCombo({mealId:selectedValue.value, comboId:rowData.id}))
      onToggle(rowData['tableData']['id']);
   }

   const handleDelete = async (mealComboId) => {
      await dispatch(deleteMealCombo({mealComboId, comboId:rowData.id}))
      onToggle(rowData['tableData']['id']);
   }
    
      // const [options, setOptions] = useState(state.data.map(d => d.name))
    
    return (
        <List dense={false} style={{marginLeft:'10%', width:'40%'}}>
          <ListItem>
          <div style={{width: '300px'}}>
          <Select
        value={selectedValue}
        onChange={handleSelectChange}
        options={options}
        // isDisabled={isEdit }
      />

          </div>
              <IconButton edge="end" aria-label="add" style={{marginLeft:10}} disabled={options.length === 0 ? true : false} onClick={handleAdd}>
                <AddIcon  />
              </IconButton>
          </ListItem>

          {
            dishes &&
            dishes.map(d => (
              <ListItem key={d.mealcombo_id}>
                <ListItemText
                  primary={`${d.id}. ${d.name}`}
                />
                <ListItemSecondaryAction>
                  <IconButton edge="end" aria-label="delete" onClick={e => {
                          handleDelete(d.mealcombo_id);
                        }}>
                    <DeleteIcon />
                  </IconButton>
                </ListItemSecondaryAction>
              </ListItem>
            ))
          }
      </List>
    )}

export default DetailPanel;
